// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Avatar } from "../Avatar/Avatar";
import { Body } from "../Typography";
import clsx from 'clsx';
import { UserWithCompanyAvatar } from "../Avatar/UserWithCompanyAvatar";
import { getInitials } from "../../common/utils";
export function ListItem(_ref) {
  var _option$avatarSrc, _option$avatarFallbac, _option$label;
  var option = _ref.data,
    innerRef = _ref.innerRef,
    isFocused = _ref.isFocused,
    innerProps = _ref.innerProps,
    useNewColors = _ref.useNewColors;
  var avatarSrc = option.avatarSrc,
    avatarFallbackColor = option.avatarFallbackColor,
    label = option.label,
    companyName = option.companyName,
    companyAvatarSrc = option.companyAvatarSrc,
    companyAvatarFallbackColor = option.companyAvatarFallbackColor,
    companyId = option.companyId;
  return /*#__PURE__*/React.createElement("div", _extends({
    key: option.value,
    ref: innerRef
  }, innerProps, {
    className: clsx('cop-flex cop-cursor-pointer cop-items-center cop-gap-3 cop-px-3 hover:cop-bg-gray-100', {
      'cop-h-10': !!companyId,
      // if an option has company to render, the option should have a height of 40px
      'cop-h-8': !companyId,
      // if an option has no company to render, the option should have a height of 32px
      'cop-bg-primary': isFocused
    })
  }), option.type !== 'company' ? /*#__PURE__*/React.createElement(UserWithCompanyAvatar, {
    size: "sm",
    avatarSrc: (_option$avatarSrc = option.avatarSrc) !== null && _option$avatarSrc !== void 0 ? _option$avatarSrc : '',
    fallbackColor: (_option$avatarFallbac = option.avatarFallbackColor) !== null && _option$avatarFallbac !== void 0 ? _option$avatarFallbac : '',
    text: getInitials((_option$label = option.label) !== null && _option$label !== void 0 ? _option$label : '', true),
    companyText: getInitials(companyName !== null && companyName !== void 0 ? companyName : ''),
    companyAvatarSrc: companyAvatarSrc !== null && companyAvatarSrc !== void 0 ? companyAvatarSrc : '',
    companyAvatarFallbackColor: companyAvatarFallbackColor !== null && companyAvatarFallbackColor !== void 0 ? companyAvatarFallbackColor : '',
    useNewColors: useNewColors
  }) : /*#__PURE__*/React.createElement(Avatar, {
    src: avatarSrc,
    fallbackColor: avatarFallbackColor !== null && avatarFallbackColor !== void 0 ? avatarFallbackColor : '',
    text: label.charAt(0).toLocaleUpperCase(),
    alt: label,
    size: "sm",
    variant: 'rounded',
    useNewColors: useNewColors
  }), /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-flex-col cop-text-[10px]"
  }, /*#__PURE__*/React.createElement(Body, {
    className: "cop-truncate",
    size: "sm"
  }, option.label), companyName && /*#__PURE__*/React.createElement("span", {
    className: "cop-text-secondary"
  }, companyName)));
}
